import { Button } from '@axo/ui-core/components/Button';
import { Icon } from '@axo/ui-core/components/Icon';

import { classNames } from '@axo/shared/util/dom';
import styles from './AcceptDeclineButtons.module.scss';

type AcceptDeclineButtonsProps = {
  isVisible: boolean;
  onAccept: () => void;
  onDecline: () => void;
};

export const AcceptDeclineButtons = ({
  isVisible,
  onAccept,
  onDecline,
}: AcceptDeclineButtonsProps) => {
  if (!isVisible) return null;

  return (
    <div className={styles.acceptDeclineButtons}>
      <Button
        iconOnly
        onClick={onDecline}
        aria-label="Dismiss suggestion"
        className={classNames(styles.button, styles.iconDecline)}
        size="xs"
      >
        <Icon name="x" />
      </Button>
      <Button
        iconOnly
        onClick={onAccept}
        aria-label="Accept suggestion"
        className={classNames(styles.button, styles.iconConfirm)}
        size="xs"
      >
        <Icon name="check" />
      </Button>
    </div>
  );
};
